import {
  ChangeDetectorRef,
  Directive,
  ElementRef,
  HostListener,
  Renderer2
} from "@angular/core";
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from "@angular/forms";

@Directive({
  selector: 'rad-checkbox',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: RadCheckboxDirective,
      multi: true
    }
  ]
})
export class RadCheckboxDirective implements ControlValueAccessor {
  constructor(private element: ElementRef, private renderer: Renderer2, private cdr: ChangeDetectorRef) {
    this.onChange = () => {};
    this.onTouched = () => {};
  }

  onChange: (value: boolean) => void;
  onTouched: () => void;

  writeValue(value: boolean) {
    this.renderer.setProperty(this.element.nativeElement, 'checked', value);
  }

  @HostListener('change', ['$event'])
  _handleChange(event: any) {
    if (event) {
        this.onChange(event.target.value.checked);
        this.cdr.detectChanges();
    }
  }


  registerOnChange(fn: (value: boolean) => void) {
    this.onChange = (event) => {
      fn(event);
    };
  }

  registerOnTouched(fn: () => void) {
    this.onTouched = fn;
  }

  setDisabledState(isDisabled: boolean) {
    this.renderer.setProperty(this.element.nativeElement, 'disabled', isDisabled);
  }

}
